// Dev-only logging helper — silenced in production to avoid leaking internals.
const isDev = process.env.NODE_ENV !== "production";

export const logError = (...args) => {
  if (isDev) console.error(...args);
};

export const logDebug = (...args) => {
  if (isDev) console.debug(...args);
};
